/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * スライド単価マスタ更新情報
 */
export interface Szza029aRequestSlideTankaMasterUpdateInfDto { 
    /**
     * 調整単価コード：数字<br>　画面項目ID＝\'C001300\'
     */
    choseiTankaCode: string;
    /**
     * 計算年月(年)：数字
     */
    calcYmt: string;
    /**
     * 適用開始日付(変更前)：日付(yyyyMMdd)<br>　「マスタ登録区分」＝\'2\'（変更）、\'3\'（削除）の場合に設定
     */
    applyStartDateBefore?: string;
    /**
     * 適用開始日付(変更後)：日付(yyyyMMdd)<br>　「マスタ登録区分」＝\'1\'（追加）、\'2\'（変更）の場合に設定
     */
    applyStartDate?: string | null;
    /**
     * 適用終了日付：日付(yyyyMMdd)
     */
    applyEndDate: string;
    /**
     * 更新通番号：数字<br>　「マスタ登録区分」＝\'2\'（変更）、\'3\'（削除）の場合に設定
     */
    updateSrno?: string;
    /**
     * 調整単価：数字<br>　精度(3)、マイナス有り
     */
    choseiTanka: number;
}

